import {hasPermission, isAdmin} from 'common/HelperFunctions'
import constants from 'common/constants'
import {useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {Outlet, useSearchParams} from 'react-router'
import {getBranches} from 'setup/redux/Actions/General/getBranch'
import {getTenantSessions} from 'setup/redux/Actions/Site/site'

const IframeLayout = () => {
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()

  const [branch, setBranch] = useState<any>(null)
  const [activeSession, setActiveSession] = useState<any>(null)

  const loadBranches = () => {
    const onSuccess = (res: any) => {
      const allBranches = res.result

      const permittedBranches = [{id: '', name: 'All Branches'}]

      for (let i = 0; i < allBranches.length; i++) {
        const b = allBranches[i]
        if (isAdmin()) {
          permittedBranches.push(b)
        } else if (hasPermission(`branch_permission_${b.id}`)) {
          permittedBranches.push(b)
        }
      }

      const branchId = searchParams.get('branch_id')

      if (branchId) {
        const br = permittedBranches.find((b) => b.id == branchId)

        if (br) {
          setBranch(br)
          localStorage.setItem('branch', br.id)
        } else {
          setBranch(null)
          localStorage.removeItem('branch')
        }
      } else {
        setBranch(null)
        localStorage.removeItem('branch')
      }
    }

    dispatch(getBranches({}, onSuccess))
  }

  const loadSessions = () => {
    const onSuccess = (res: any) => {
      const _sessions = res.result
      const dBPostFix = searchParams.get('db_postfix')
      const currentSession = _sessions.find((session: any) => session.db_postfix == dBPostFix)

      if (currentSession) {
        setActiveSession(currentSession)
        localStorage.setItem(constants.session_db_postfix_key, JSON.stringify(currentSession))
      }

      loadBranches()
    }

    dispatch(getTenantSessions(onSuccess))
  }

  useEffect(() => {
    loadSessions()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams])

  return (
    <div className='d-flex flex-column min-vh-100'>
      <div className='flex-grow-1 container-fluid my-5'>
        <div className='row mb-3'>
          {branch && (
            <div className='col-6'>
              <span className='badge fs-7 float-start' style={{backgroundColor: '#f36a5a'}}>
                {branch.name}
              </span>
            </div>
          )}

          {activeSession && activeSession?.db_postfix && (
            <div className={branch ? 'col-6' : 'col-12'}>
              <span
                className='badge ms-1 fs-7 float-end'
                style={{backgroundColor: 'var(--bs-teal)'}}
              >
                Session: {activeSession.name}
              </span>
            </div>
          )}
        </div>

        <Outlet />
      </div>
    </div>
  )
}

export default IframeLayout
